<template>
  <div>
    <Navbar />
    <div class="bg-gradient-midnight nav-offset-spacing min-h-screen">
      <div class="standard-spacing">
        <h1 class="heading-1 md:mt-16">Contact us</h1>
        <ClientOnly>
          <div class="md:flex items-start justify-between mt-16">
            <div class="w-full md:w-1/2">
              <ContactForm from="contact" />
            </div>
            <div class="w-full md:w-1/2 flex flex-col items-center mt-8 md:mt-0">
              <div class="w-full md:w-auto md:mx-auto md:flex md:flex-col justify-between items-center">
                <HoapButton
                  :url="config.public.calendlyURL"
                  external
                  variant="large"
                  label="Book a demo"
                  class="mb-3 md:mb-8 w-full text-center block" />
                <HoapButton
                  :url="config.public.buyUrl"
                  external
                  inverted
                  variant="large"
                  label="Get started today!"
                  class="w-full text-center block" />
              </div>
            </div>
          </div>
          <Subscribe transparent :with-spacing="false" class="pt-16" />
          <div class="md:flex py-16">
            <div class="w-full md:w-1/2 md:px-16">
              <div v-if="config.public.contactEmail" :class="contactDetailClasses">
                <div :class="contactDetailKeyClasses">Email</div>
                <a
                  :href="`mailto:${config.public.contactEmail}`"
                  class="hoap-link"
                  target="_blank"
                  rel="noreferrer"
                  :class="contactDetailValueClasses">
                  {{ config.public.contactEmail }}
                </a>
              </div>
              <div
                v-if="contactDetails && contactDetails.address_line_1 && contactDetails.address_line_2"
                :class="[contactDetailClasses, 'mt-4 md:mt-8']">
                <div :class="contactDetailKeyClasses">Address</div>
                <a
                  href="https://goo.gl/maps/6wDW6yeXXL3RdqvW9"
                  class="hoap-link"
                  target="_blank"
                  rel="noreferrer"
                  :class="contactDetailValueClasses">
                  {{ contactDetails.address_line_1 }} {{ contactDetails.address_line_2 }}
                </a>
              </div>
            </div>
            <div class="w-full md:w-1/2 flex md:px-16 mt-8 md:mt-0">
              <div class="font-decorative text-xl md:text-4xl mt-1 md:mt-2">Get Social,</div>
              <div class="pl-4">
                <SocialLink
                  v-for="social in socials"
                  :key="social.url"
                  :url="social.url"
                  :socialName="social.name"
                  class="mb-2" />
              </div>
            </div>
          </div>
        </ClientOnly>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useQuery } from '@vue/apollo-composable'
  import { GET_SOCIALS, GET_CONTACT_DETAILS } from '~~/queries'

  const config = useRuntimeConfig()

  type SettingType = { key: string; value: string }

  const contactDetailClasses = 'grid grid-cols-5 gap-x-4 md:gap-x-8 text-lg'
  const contactDetailKeyClasses = 'text-sm md:text-base col-span-2'
  const contactDetailValueClasses = 'text-sm md:text-base col-span-3 font-light'

  const { result: socialsResult } = useQuery(GET_SOCIALS)
  const { result: contactDetailsResult } = useQuery(GET_CONTACT_DETAILS)

  const socials = computed(() => socialsResult.value?.socials)
  const contactDetails = computed(() =>
    contactDetailsResult.value?.settings.reduce(
      (settings: SettingType, setting: SettingType) => ({ ...settings, [setting.key]: setting.value }),
      {}
    )
  )

  setMetadata({ pageTitle: 'Contact us' })
</script>
